const DOMAIN = 'lookiero';

export const getTopLevelDomain = hostname => {
  const hostnameSplit = hostname.split('.');
  const domainPosition = hostnameSplit.indexOf(DOMAIN);

  return hostnameSplit.slice(-(hostnameSplit.length - domainPosition)).join('.');
};
